// removed by extract-text-webpack-plugin
module.exports = {"block":"EmptyAvatar_block_2CUfU","initials":"EmptyAvatar_initials_2jH3U","circle":"EmptyAvatar_circle_v370s"};